/**
 * @generated SignedSource<<79e5ebb002cfb162b3788d94b2a68b2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditImagePageInput = {
  clientMutationId?: string | null;
  image: string;
  internalTitle: string;
  messageDefinitionId: string;
  pageId: string;
};
export type useMessagePageMutations_EditImagePageMutation$variables = {
  input: EditImagePageInput;
};
export type useMessagePageMutations_EditImagePageMutation$data = {
  readonly Admin: {
    readonly MessageDefinitions: {
      readonly editImagePage: {
        readonly messageDefinition: {
          readonly node: {
            readonly id: string;
          };
        };
      } | null;
    };
  };
};
export type useMessagePageMutations_EditImagePageMutation = {
  response: useMessagePageMutations_EditImagePageMutation$data;
  variables: useMessagePageMutations_EditImagePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MessageDefinitionsAdminMutationSchema",
        "kind": "LinkedField",
        "name": "MessageDefinitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "EditImagePagePayload",
            "kind": "LinkedField",
            "name": "editImagePage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MessageDefinitionsEdge",
                "kind": "LinkedField",
                "name": "messageDefinition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageDefinition",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMessagePageMutations_EditImagePageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMessagePageMutations_EditImagePageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ffcfa2fab968549d2fe229c6c216ce19",
    "id": null,
    "metadata": {},
    "name": "useMessagePageMutations_EditImagePageMutation",
    "operationKind": "mutation",
    "text": "mutation useMessagePageMutations_EditImagePageMutation(\n  $input: EditImagePageInput!\n) {\n  Admin {\n    MessageDefinitions {\n      editImagePage(input: $input) {\n        messageDefinition {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "865960285121ebf8198aa6fb723027e8";

export default node;
